module.exports = __webpack_public_path__ + "static/media/Thought-leaders-planting-saxal.a42337ce.jpg";